import React, { useMemo } from "react";

const Loading: React.FC = () => {
  const sentences = [
    { text: "Connecting your rewards" },
    { text: "Gearing up for greatness" },
    { text: "Unlocking something magic" },
    { text: "Finding your favorites" },
    { text: "Turning visits into rewards" },
    { text: "Good things are coming" },
    { text: "Loading happiness" },
    { text: "Lokalai loading" },
    { text: "Powering up the vibes" },
    { text: "Unlocking your Lokalai journey" },
    { text: "Building your experience" },
    { text: "The magic is coming" },
  ];

  const randomSentence = useMemo(
    () => sentences[Math.floor(Math.random() * sentences.length)],
    []
  );

  return (
    <section className="flex flex-col items-center justify-center gap-8 w-full min-h-[300px] text-white">
      <div className="relative mb-3 animate-updown">
        {/* Spinning marker */}
        <div className="h-[100px] w-[100px] border-[6px] border-redlight rotate-45 rounded-[50%_50%_0%_50%] relative mb-8 shadow-redlight/20 shadow-xl">
          <div className="absolute h-[60%] w-[60%] rounded-full border-[8px] border-transparent border-t-redlight border-b-redlight top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-rotate" />
          <div className="absolute top-1/2 left-1/2 w-12 h-12 bg-dry rounded-full animate-glowPulse" />
          <div className="absolute top-[35px] left-[35px] w-[20px] h-[20px] bg-[#ff0000] rounded-full" />
        </div>

        {/* Foot arc – now moves in sync */}
        <svg
          className="absolute bottom-[-15px] left-1/2 transform -translate-x-1/2"
          width="40"
          height="40"
          viewBox="0 0 120 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 40 Q60 -20 120 40 Q60 10 0 40 Z" fill="#f87171" />
        </svg>
      </div>

      <div className="flex items-center gap-3">
        <p className="text-base sm:text-sm font-normal tracking-wide text-white">
          {randomSentence.text}
        </p>
        <div className="loader-dots animate-dotBounce bg-redlight"></div>
      </div>
    </section>
  );
};

export default Loading;
